import { IconButton } from "@mui/material"
import { MoreVertOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { SHOULD_SHOW_UNIMPLEMENTED } from "../../constants"

import { ProductInventoryHeaderInfo } from "./ProductInventoryHeaderInfo"
import { ProductInventoryHeaderSpecs } from "./ProductInventoryHeaderSpecs"

import type { Product } from "@/graphql/codegen/graphql"

interface ProductInventoryHeaderProps {
  product: Product
}

export const ProductInventoryHeader: FC<ProductInventoryHeaderProps> = ({ product }) => {
  return (
    <div className='relative flex items-stretch justify-between gap-6 rounded-md border border-solid border-gray-300 px-6 py-4'>
      <ProductInventoryHeaderInfo product={product} />
      <ProductInventoryHeaderSpecs product={product} />
      {SHOULD_SHOW_UNIMPLEMENTED && (
        <IconButton
          size='small'
          className='self-start'
          data-testid='product-inventory.header.menu-button'
          aria-label='More options'
        >
          <MoreVertOutlined />
        </IconButton>
      )}
    </div>
  )
}
